import { createContext } from "react";

import { RouteInfo } from "@voxmedia/duet-utils/route";

export interface RouteInfoContext {
  routeInfo: RouteInfo | null;
}

const RouteInfoReactContext = createContext<RouteInfoContext | null>(null);

export default RouteInfoReactContext;
